export const isSurflineHostname = (hostname: string): boolean =>
  hostname === 'surfline.com' || hostname.endsWith('.surfline.com');

/** True when the current web host is not a Surfline production domain (e.g. preview, localhost). */
export const isPreviewDomainForSignIn = (): boolean =>
  typeof window !== 'undefined' && !isSurflineHostname(window.location.hostname);
